<template>
  <v-card>
    <v-tabs v-model="tab" bg-color="secondary" color="white">
      <v-tooltip location="top" text="Configurações do evento">
        <template v-slot:activator="{ props }">
          <v-tab :value="1" v-bind="props">
            <v-icon>mdi-cog</v-icon> Evento
          </v-tab>
        </template>
      </v-tooltip>
      <v-tooltip location="top" text="Participantes" v-if="value.id">
        <template v-slot:activator="{ props }">
          <v-tab :value="2" v-bind="props">
            <v-icon>mdi-account-multiple-plus</v-icon> Participantes
          </v-tab>
        </template>
      </v-tooltip>
      <v-tooltip location="top" text="Ajudantes/Assistentes" v-if="value.id">
        <template v-slot:activator="{ props }">
          <v-tab :value="3" v-bind="props">
            <v-icon>mdi-account-hard-hat</v-icon> Ajudantes
          </v-tab>
        </template>
      </v-tooltip>
      <v-tooltip location="top" text="Arquivos do evento" v-if="value.id">
        <template v-slot:activator="{ props }">
          <v-tab :value="4" v-bind="props">
            <v-icon>mdi-paperclip</v-icon> Arquivos
          </v-tab>
        </template>
      </v-tooltip>
    </v-tabs>

    <v-card-text>
      <v-window v-model="tab">
        <v-window-item :value="1">
          <v-form :submit="submitUpdate">
            <v-row>
              <v-col cols="4">
                <v-text-field
                              label="Nome"
                              v-model="value.name"
                              :rules="rules.required"
                              density="compact"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                              label="Nome/Ref. do lugar"
                              v-model="value.address_name"
                              density="compact"
                              :rules="rules.required"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                              type="date"
                              label="Início"
                              density="compact"
                              v-model="value.start_date"
                              :rules="rules.required">
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                              label="Local"
                              v-model="value.address"
                              density="compact"
                              :rules="rules.required"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                              label="Link do mapa"
                              v-model="value.map_link"
                              density="compact"
                              prepend-inner-icon="mdi-map"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                              label="Meio de transporte"
                              v-model="value.transportation_method"
                              density="compact"
                              prepend-inner-icon="mdi-train-car"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-card variant="tonal">
                  <v-card-title primary-title> Saída e chegada </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="4">
                        <v-row class="ma-0 pa-0">
                          <v-col cols="8" class="ma-0 pa-0">
                            <v-text-field
                                          type="date"
                                          label="Data de saída"
                                          density="compact"
                                          v-model="value.exit_point_date">
                            </v-text-field>
                          </v-col>
                          <v-col cols="4" class="ma-0 pa-0">
                            <v-text-field
                                          type="text"
                                          label="hh:mm"
                                          density="compact"
                                          v-model="value.exit_point_time"
                                          v-mask="'##:##'"
                                          append-inner-icon="mdi-clock">
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <v-text-field
                                      label="Nome/Ref. do lugar de saída"
                                      v-model="value.exit_point_address_name"
                                      density="compact"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                                      label="Endereço de saída"
                                      v-model="value.exit_point_address"
                                      density="compact"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                                      label="Link do mapa do lugar de saída"
                                      v-model="value.exit_point_map_link"
                                      density="compact"
                                      prepend-inner-icon="mdi-map"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <hr />
                      </v-col>
                      <v-col cols="4">
                        <v-row class="ma-0 pa-0">
                          <v-col cols="8" class="ma-0 pa-0">
                            <v-text-field
                                          type="date"
                                          label="Data da chegada"
                                          density="compact"
                                          v-model="value.arrival_point_date">
                            </v-text-field>
                          </v-col>
                          <v-col cols="4" class="ma-0 pa-0">
                            <v-text-field
                                          type="text"
                                          label="hh:mm"
                                          density="compact"
                                          v-model="value.arrival_point_time"
                                          v-mask="'##:##'"
                                          append-inner-icon="mdi-clock">
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="8">
                        <v-text-field
                                      label="Nome/Ref. do lugar de chegada"
                                      v-model="value.arrival_point_address_name"
                                      density="compact"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                                      label="Endereço de chegada"
                                      v-model="value.arrival_point_address"
                                      density="compact"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                                      label="Link do mapa do lugar de chegada"
                                      v-model="value.arrival_point_map_link"
                                      density="compact"
                                      prepend-icon="mdi-map"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12">
                <AutocompleteSelectCreateLegalPerson
                                                     :user="user"
                                                     :customTypes="[$LEGAL_PEOPLE_TYPES_DIC.PADRAO]"
                                                     v-model="value.coordinator"
                                                     label="Selecione o coordenador"
                                                     :rules="rules.required" />
              </v-col>

              <v-col cols="6">
                <v-textarea
                            label="Descrição do evento"
                            v-model="value.description"
                            :rules="rules.required"
                            density="compact"></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea
                            label="Resumo da programação"
                            v-model="value.summary"
                            :rules="rules.required"
                            density="compact"></v-textarea>
              </v-col>

              <v-col cols="12" class="text-right">
                <v-btn color="success" type="submit"><v-icon class="mr-2">mdi-content-save</v-icon> Salvar</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-window-item>
        <v-window-item :value="2">
          <FormInvitees
                        :user="user"
                        :eventId="value.id"
                        v-model="invitees"
                        @loadInvitees="loadInvitees"
                        @updated="loadInvitees"
                        :loading="requestingApi" />
        </v-window-item>
        <v-window-item :value="3">
          <FormEventStaff
                          :user="user"
                          :eventId="value.id"
                          v-model="eventStaff"
                          @loadEventStaff="loadEventStaff"
                          @updated="loadEventStaff"
                          :loading="requestingApi" />
        </v-window-item>
        <v-window-item :value="4">
          <v-row>
            <v-col cols="12" v-if="requestingApi">
              <h3>Carregando ...</h3>
            </v-col>
            <v-col cols="12">
              <p class="text-overline">Adicionar arquivo</p>
              <UploadFile
                          icon="mdi-paperclip"
                          :fileType="$FILE_TYPE.event_file"
                          :userId="user.id"
                          :eventId="value.id"
                          @uploaded="fileUploaded"
                          density="compact"
                          :loading="requestingApi"
                          :disabled="requestingApi" />
            </v-col>
            <v-col cols="12" v-if="eventFiles && eventFiles.length > 0">
              <v-list lines="one" density="compact">
                <div v-for="(file, ixfl) in eventFiles"
                     :key="ixfl">

                  <v-list-item

                               :title="file.original_name">
                    <template v-slot:append>
                      <v-btn
                             :disabled="requestingApi"
                             color="red"
                             variant="text"
                             icon
                             size="medium"
                             class="ml-2"
                             density="compact"
                             @click="deleteFile(file, ixfl)"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <template v-slot:prepend>
                      <v-btn
                             :disabled="requestingApi"
                             color="primary"
                             variant="text"
                             icon
                             size="medium"
                             class="mr-2"
                             density="compact"
                             @click="downloadFile(file)"><v-icon>mdi-download</v-icon></v-btn>
                    </template>
                  </v-list-item>

                  <v-divider></v-divider>
                </div>
              </v-list>
            </v-col>
          </v-row>
        </v-window-item>
      </v-window>
    </v-card-text>
  </v-card>
</template>
<script>
import AutocompleteSelectCreateLegalPerson from "./AutocompleteSelectCreateLegalPerson.vue";
import FormEventStaff from "./FormEventStaff.vue";
import FormInvitees from "./FormInvitees.vue";
import ListFromTo from "./ListFromTo.vue";
import UploadFile from "./UploadFile.vue";
import api from '@/services'
import functions from '@/services/Functions'
export default {
  components: { ListFromTo, FormInvitees, FormEventStaff, UploadFile, AutocompleteSelectCreateLegalPerson },
  props: {
    user: Object,
    modelValue: Object,
  },
  emits: ["update:modelValue", "created"],
  data() {
    return {
      requestingApi: false,
      tab: 1,
      invitees: [],
      eventStaff: [],
      eventFiles: [],
      searchText: null,
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
      },
    };
  },
  created() {
    var vm = this;
    if (!vm.modelValue?.id) {
      vm.value = vm.generateEmpty();
    }
  },
  mounted() { },
  methods: {
    submitUpdate() {
      const vm = this;

      if (vm.$moment(vm.value.exit_point_date).isAfter(vm.$moment(vm.value.start_date))) {
        vm.$notify({
          type: "warning",
          text: "Saída posterior ao início do evento",
        });
        return;
      }

      if (vm.$moment(vm.value.arrival_point_date).isBefore(vm.$moment(vm.value.start_date))) {
        vm.$notify({
          type: "warning",
          text: "Chegada anterior ao início do evento",
        });
        return;
      }

      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.event
            .updateOrCreate(vm.value)
            .then((result) => {
              if (vm.value.id) {
                vm.$emit("update:modelValue", result);
                vm.$notify({
                  type: "success",
                  text: "Evento atualizado com sucesso",
                });
              } else {
                vm.value = result;
                vm.$emit("created", result);
                vm.$notify({
                  type: "success",
                  text: "Evento criado com sucesso",
                });
              }
              resolve(result);
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
              reject(err);
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    loadInvitees() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.eventInvitation
          .list({ event_id: vm.value.id || null })
          .then((result) => {
            vm.invitees = (result?.data || result || []).map((i) => {
              // const STATUS_PENDING = 0;
              // const STATUS_DECLINED = 5;
              // const STATUS_ACCEPTED = 10;
              let _color = null;
              switch (i.status) {
                case 0:
                  break;
                case 5:
                  _color = "red";
                  break;
                case 10:
                  _color = "green";
                  break;
                default:
                  break;
              }
              return {
                ...i.legal_person,
                from_to_color: _color,
              };
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    loadEventStaff() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.eventStaff
          .list({ event_id: vm.value.id || null })
          .then((result) => {
            vm.eventStaff = (result?.data || result || []).map((i) => {
              return { ...i.legal_person };
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    loadEventFiles() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.eventFile
          .list({ event_id: vm.value.id || null })
          .then((result) => {
            vm.eventFiles = result?.data || result || [];
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    fileUploaded(file) {
      var vm = this;
      vm.eventFiles.push(file);
    },
    downloadFile(file) {
      window.open(file.path, "_blank");
    },
    deleteFile(file, index) {
      var vm = this;
      let _confirm = confirm(
        `Deseja realmente escluir o arquivo ${file.original_name}`
      );
      if (_confirm) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.file
            .delete(file)
            .then((result) => {
              vm.eventFiles.splice(index, 1);
              vm.$notify({
                type: "success",
                text: "Arquivo removido",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    generateEmpty() {
      return {
        name: null,
        description: null,
        summary: null,
        date: null,
        start_date: null,
        address_name: null,
        address: null,
        map_link: null,
        meeting_point_address_name: null,
        meeting_point_address: null,
        meeting_point_map_link: null,
        meeting_point_date: null,
        exit_point_address_name: null,
        exit_point_address: null,
        exit_point_map_link: null,
        exit_point_date: null,
        transportation_method: null,
        coordinator: null,
        coordinator_id: null,
        invitees: [],
      };
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    "value.coordinator"(newVal) {
      if (newVal?.id) {
        this.value.coordinator_id = newVal.id
      } else {
        this.value.coordinator_id = null
      }
    },
    tab(newVal) {
      if (newVal == 4) {
        this.loadEventFiles()
      }
    }
  },
};
</script>